module.exports = __webpack_public_path__ + "static/media/input.a5e3e9a9.svg";